import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOverlays } from '../../../actions/OverlayActions.redux';
import { addTileLayer } from '../../interface/';
import { isTileOverlay } from '../../../utils/overlays';

const useRenderings = ({ isMapReady = false }) => {
  const [firstLoadComplete, setFirstLoadComplete] = useState(false);
  const overlays = useSelector((state) => state.overlays);
  const map = useSelector((state) => state.config.map);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!isMapReady) return undefined;
    dispatch(fetchOverlays(map));
    return undefined;
  }, [dispatch, map, isMapReady]);

  useEffect(() => {
    if (!firstLoadComplete && overlays.length > 0) {
      overlays.filter(isTileOverlay).forEach((overlay) => {
        addTileLayer(overlay);
      });
      setFirstLoadComplete(true);
    }
  }, [overlays, firstLoadComplete]);

  return null;
};

export default useRenderings;
